export function mapToArray(map) {
  let array = [];
  for (let [_id, value] of map) {
    array.push(value);
  }
  return array;
}

export function arrayToTree(array, parentProperty = 'parent_id', idProperty = 'id') {
  const idToItemMap = {};
  const parents = [];

  array.forEach(item => {
    // There's some global state shenanigans where the 'children' property of
    // a parent category is ending up with duplicate children. To avoid
    // this, we clone the parent so that the object we're mutating here is
    // not the same as the category object stored in the global state.
    idToItemMap[item[idProperty]] = structuredClone(item);
  });

  array.forEach(item => {
    if (item[parentProperty] !== null) {
      const parent = idToItemMap[item[parentProperty]];
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(idToItemMap[item[idProperty]]);
    } else {
      parents.push(idToItemMap[item[idProperty]]);
    }
  });

  return parents;
}

export function sortAlpha(key) {
  return function sort(a, b) {
    let keyA = a[key].toUpperCase();
    let keyB = b[key].toUpperCase();
    if (keyA < keyB) {
      return -1;
    }
    if (keyA > keyB) {
      return 1;
    }
    return 0;
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function spliceMatching(array, new_item, key) {
  let pos = array.findIndex((element) => element[key] == new_item[key]);
  if (pos == -1) {
    pos = array.length;
  }
  return [...array.slice(0, pos), new_item, ...array.slice(pos + 1)];
}

export function removeMatching(array, item_to_remove, key) {
  let pos = array.findIndex((element) => element[key] == item_to_remove[key]);
  array.splice(pos, 1);
  return [...array];
}

export function hasOwnProperty(obj, name) {
  return Object.prototype.hasOwnProperty.call(obj, name);
}

export function idArrayToMap(array) {
  return array.reduce((accumulator, currentValue) => {
    accumulator.set(currentValue.id, currentValue);
    return accumulator;
  }, new Map());
}

export function toFloat(value) {
  return parseFloat(value) || 0;
}

export function formatToTwoDigits(number) {
  return number.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2});
}

export function formatCurrency(number) {
  return number.toLocaleString(undefined, {style: 'currency', currency: 'USD'});
}

export function formatDate(timestamp) {
  return timestamp.toLocaleDateString();
}

export const elementAndProps = (elementid) => {
  const element = document.getElementById(elementid);
  const props = JSON.parse(element.getAttribute('data-props') || '{}');
  return [element, props];
};
